import Box from '@components/base/Box'
import { Button } from '@components/inputs/Button'
import { ReactNode } from 'react'

const TableRowActions = ({
  action = [],
  deleteClicked,
  editClicked,
  confirmModal,
  disabled = false,
}: {
  action?: {
    title: string
    onClicked: () => void
    confirmModal?: { title: string; content: string | ReactNode }
    show?: boolean
    loading?: boolean
  }[]
  editClicked?: () => void
  deleteClicked?: () => void
  confirmModal?: { title: string; content: string | ReactNode }
  disabled?: boolean
}) => {
  return (
    <Box className="flex">
      {/* {action && action.show && ( */}
      <Box className="flex justify-end flex-1">
        {action.map((a) => {
          if (a.show)
            return (
              <Button
                key={a.title}
                onClick={a.onClicked}
                className="ml-auto mr-2"
                size="small"
                title={a.title ?? 'Action'}
                disabled={disabled}
                confirmationModal={a.confirmModal}
                loading={a.loading}
              />
            )
        })}
      </Box>
      {editClicked && (
        <Button
          onClick={editClicked}
          className="ml-auto mr-2"
          size="small"
          title="Edit"
          disabled={disabled}
        />
      )}
      {deleteClicked && (
        <Button
          onClick={deleteClicked}
          size="small"
          title="Remove"
          confirmationModal={!!confirmModal ? confirmModal : undefined}
          disabled={disabled}
        />
      )}
    </Box>
  )
}

export default TableRowActions
